import type { Theme } from '@mui/material'

export const spacingConstants: Theme['spacingConstants'] = {
  global: 8,
  candidateNavbarHeight: 99,
  smallCandidateNavbarHeight: 80,
  adminNavbarHeight: 52,
  desktopContainer: 568,
  worker: {
    mobileNavBarHeight: 68,
  },
}
